<template>
    <div>
        <el-container>
            <el-header height="733px"><strong>管理员主界面</strong>
                <div>
                    <el-button type="primary" @click="download()">邀请码管理</el-button>
                </div>
              <div>
                <el-button type="primary" @click="Researchermanage()">研究者管理</el-button>
              </div>
                <div>
                    <el-button type="primary" @click="downloadData()">下载数据</el-button>
                </div>
                <div>
                  <el-button type="primary" @click="downLoadReport()">下载成绩单</el-button>
                </div>

              <div>
                <el-button type="primary" @click="downLoadRecord()">下载音频/模板管理</el-button>
              </div>

            </el-header>


          <el-dialog
              title="Administrator Functions"
              :visible.sync="centerDialogVisible"
              width="70%"
              style="font-size: 26px;"
              left>
          <span>
            <div v-show="showfunction==1" style="justify-content: center">
              <div slot="title" class="header-title">
                <h3>Access Codes for Test</h3>
              </div>
              <div style="margin-bottom: 20px; margin-left: 110px">
                <el-button type="primary" @click="generate_code">生成邀请码<br/>
                  Generate test codes
                </el-button>
                <el-button type="primary" @click="mycode">我生成的邀请码<br/>
                  The code I generated
                </el-button>
                <el-button type="primary" @click="Rechercode">下载研究人员相关邀请码<br/>
                  Download codes related with Researchers
                </el-button>
<!--                <el-button type="primary" @click="mycode">我生成的邀请码<br/>-->
<!--                  The code I generated-->
<!--                </el-button>-->
              </div>
            </div>

            <div v-show="showfunction==2" style="justify-content: center">
              <div slot="title" class="header-title">
                <h3>
                  Datasets Download and Manage templates
                </h3>
              </div>
              <div style="margin-bottom: 20px; margin-left: 110px">
               <el-input v-model="input" placeholder="请输入研究者账号" style="width: 250px;margin-right: 10px"></el-input>
                <el-button type="primary" @click="download_data_remail">搜索研究者下载音频
                </el-button>

              </div>
              <div style="margin-bottom: 20px; margin-left: 110px">
                <el-button type="primary" @click="generate_template">生成评分模板
                </el-button>
                <el-button type="primary" @click="download_template">下载模板xls表
                </el-button>

                <el-upload
                    class="upload-demo"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-change="handlePreview"
                    multiple
                    :limit="1"
                    :on-exceed="handleExceed"
                    :file-list="fileList">
                  <el-button slot="trigger"  type="primary">选取文件</el-button>
                 <el-button type="primary" style="margin-top: 20px; margin-left: 10px" @click="upload_template">上传模板xls表
                </el-button>
                 <div slot="tip" class="el-upload__tip">只能上传xls文件，且不超过500kb</div>
</el-upload>
              </div>
            </div>
            <div v-show="showfunction==4" style="justify-content: center">
              <div slot="title" class="header-title">
                <h3> Demo Test</h3>
              </div>
              <div style="margin-bottom: 20px; margin-left: 110px">
                <el-button type="primary" @click="demo_W">文字版测试演示<br/>
                  Written Demo Test
                </el-button>
                <el-button type="primary" @click="demo_A">试听版测试演示<br/>
                  Aural Demo Test
                </el-button>
              </div>
            </div>

          </span>

          </el-dialog>


        </el-container>

    </div>
</template>

<script>
import GLOBAL from "../../../src/plugins/global_variable";
    export default {
        name: "Adminindex",
        data() {
            return {
                // user不一定能用到
              admin: {
                    id: '',
                    account: '',
                    pwd: '',
                },
              showfunction:'',
              centerDialogVisible: false,
              downloadt:false,
              upload:false,
              fileList:[],
              input:'',
              Reemail:'',

            };
        },
        methods: {
            download() {
              this.showfunction = 1
              this.centerDialogVisible = true
                // this.$router.push('/AdminCode');
            },
            downloadData(){
                this.$router.push("/AdminDownloadData")
            },
            downLoadReport() {
                this.$router.push("/AdminDownloadReport")
            },
            downLoadRecord(){
              this.showfunction = 2
              this.centerDialogVisible = true
            },

            generate_code() {
              GLOBAL.Adminaccount = this.admin.account
              this.$router.push('/Researchercode');
            },

            mycode() {
              var _this = this;
              axios.get('/invite/findByR_email' + _this.Reemail).then((resp) => {
                    var codelist = resp.data
                    GLOBAL.codeinfolist = codelist
                    console.log(GLOBAL.codeinfolist)
                  }
              );

              _this.$router.push('/Researcherviewcode');
            },

            Rechercode(){
              var _this = this;

            },

            Researchermanage(){
              this.$router.push('/AdminResearcherManage');
            },



            generate_template() {
              this.downloadt = true
              axios({
                url: "/uploadExcel/generateTemplate?remail=tall-webtest@qq.com" ,
                responseType: 'blob'
              }).then((resp) => {
                console.log(resp.data)
              })
              console.log("!")
            },

            download_template() {
              this.upload = true
              let fileName = "rating_template.xls"
              console.log( this.admin.account)
              axios({
                url: "/uploadExcel/downloadTemplate?remail=tall-webtest@qq.com",
                responseType: 'blob'
              }).then((response) => {
                if ('download' in document.createElement('a')) { // 非IE下载
                  const content = response.data
                  const blob = new Blob([content])
                  const elink = document.createElement('a')
                  elink.download = fileName
                  elink.style.display = 'none'
                  elink.href = URL.createObjectURL(blob)
                  document.body.appendChild(elink)
                  elink.click()
                  URL.revokeObjectURL(elink.href) // 释放URL 对象
                  document.body.removeChild(elink)
                  this.generate = !this.generate

                } else { // IE10+下载
                  navigator.msSaveBlob(blob, fileName)
                }
              })
            },

            handleRemove(file, fileList) {
              console.log(file, fileList);
            },

            handlePreview(file) {
              this.fileList = fileList;

              console.log(file);
            },

            upload_template(){
              console.log("上传评分模板")
              let new_file = new FormData()
              new_file.append('key', 'file')
              this.fileList.forEach(item=>{
                //文件信息中raw才是真的文件
                new_file.append("value",item.raw);
                console.log(item.raw)
              })

              // axios.post('/uploadExcel/importRecordInfo',)
              this.$axios.post('/uploadExcel/importRecordInfo',new_file).then(res=>{
                if (res.data.code === 200) {
                  //console.log(res);
                  this.$message('上传成功')
                }else{
                  this.$message('失败')
                }
              })

            },

          download_data_remail(){
              let remail = this.input
              console.log(remail)
              // /researcher/send_records/
          }


        },
        created() {//生命周期函数
            var adminString = localStorage.getItem("admin");
            if (adminString) {
                this.admin = JSON.parse(adminString);
            } else {
                alert("您尚未登录，点击确定跳转至登录页面");
                this.$router.push('/admin/Adminlogin');
            }


        }
    }
</script>

<style scoped>
    .el-header, .el-footer {
        color: #333;
        text-align: center;
        line-height: 60px;
    }

    .el-aside {
        background-color: #D3DCE6;
        color: #333;
        text-align: center;
        line-height: 200px;
    }

    .el-main {
        background-color: #E9EEF3;
        color: #333;
        text-align: center;
        line-height: 80px;
        align-self: center;
        width: 700px;
    }


    body > .el-container {
        margin-bottom: 40px;
    }

    .el-container:nth-child(5) .el-aside,
    .el-container:nth-child(6) .el-aside {
        line-height: 260px;
    }

    .el-container:nth-child(7) .el-aside {
        line-height: 320px;
    }

    /*分栏间隔*/
    .el-row {
        margin-bottom: 20px;
    }

    .el-col {
        border-radius: 4px;
    }

    .bg-purple-dark {
        background: #99a9bf;
    }

    .bg-purple {
        background: #d3dce6;
    }

    .bg-purple-light {
        background: #e5e9f2;
    }

    .grid-content {
        border-radius: 4px;
        min-height: 36px;
    }

    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }

</style>